import LegalPageLayout from './LegalPageLayout';

/**
 * Contact — voluntarily minimalist per spec: a short intro and the clickable
 * email address. No form, no socials, no clutter.
 */
const CONTACT_EMAIL = 'helloherita@proton.me';

const Contact = () => {
  return (
    <LegalPageLayout
      eyebrow="Contact"
      title="Une question ? Écrivez-nous."
      testId="page-contact"
      seoTitle="Contact et support | HÉRITA"
      seoDescription="Contactez l'équipe Hérita : support, questions sur l'analyse d'un acte notarié, partenariats. Réponse personnelle en français sous quelques jours."
      seoPath="/contact"
    >
      <p>
        Hérita est encore une petite équipe. Nous lisons chaque message
        attentivement et vous répondons personnellement, en français, sous
        quelques jours ouvrés.
      </p>

      <p>
        Pour toute question sur le Service, sur une analyse en particulier,
        sur vos données personnelles, sur un partenariat ou sur tout autre
        sujet : écrivez-nous simplement.
      </p>

      <p style={{ marginTop: 32 }}>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="contact-email-link"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
            fontSize: '28px',
            letterSpacing: '-0.005em',
            textDecoration: 'underline',
            textUnderlineOffset: '5px',
            color: '#1A2530',
          }}
        >
          {CONTACT_EMAIL}
        </a>
      </p>
    </LegalPageLayout>
  );
};

export default Contact;
